import React from "react";

import { connect } from "react-redux";
// import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from "redux";
import Image from "../../../../../../components/ZUILib/Image/Image";
import Warning from "../../../../../../components/Warning";
import commonUtil from "../../../../../../utils/commonUtil";
import * as giftListActions from "../../actions";
import * as defaultConst from "../../../../../../utils/clientConstant";
import Warning2 from "../../../../../../components/Warning2";

const {
  getMessagesService,
  addAgainGiftItem,
  addThankYouMessage,
  getRegisteredGiftList,
} = giftListActions;

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

class Template extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageValue1: "",
      typeOfMessage: "",
      confirmModalvalue: "",
      // messageValue1: this.props.messages && this.props.messages.getMessages.thankyouMsg !== '' ? this.props.messages.getMessages.thankyouMsg : '',
    };
    this.eventId =
      this.props.params && this.props.params.eventID
        ? this.props.params.eventID
        : "";
  }

  render() {
    // const messages = this.props.messages;
    const { giftDetail, lables, giftItemID, newtoRead, eventContractInfo } = this.props;
    const giftSection = "RecibidosSection";
    const selectedGiftDetail = {...giftDetail};
    let messageStatusImage = "";
    let imageName = "";
    let messageIconClass = "";
    // const html = registeredGiftList.map(giftDetail => (<Template giftDetail={giftDetail} />));
    // giftDetail.categoryInfo.map(categoryInfo => categoryInfo.itemsInfo.map(itemInfo => itemInfo));


    //---------------------
    let messageLabel = "";
    let messageIconName = "";

    if (giftDetail.messageInfo === "new") {
      messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.message.newmsg");
      messageIconName = "icon-new-message";
    }
    if (giftDetail.messageInfo === "replied" ||giftItemID === giftDetail.purchaseItemId) {
      messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.message.ansmsg");
      messageIconName = "icon-answered";
    }

    if (
      (giftDetail.messageInfo === "opened" || newtoRead === giftDetail.purchaseItemId) && giftItemID !== giftDetail.purchaseItemId) {
        messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.message.readmsg");
        messageIconName = "icon-read";
    }

    if (giftDetail.messageInfo === "none") {
        messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.message.nomsg");
        messageIconName = "icon-no-message";
    }

    if (giftDetail.messageInfo === "no") {
        messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.deafult.message");
        messageIconName = "icon-no-message";
    }

    selectedGiftDetail.messageLabel = messageLabel;
    selectedGiftDetail.messageIconName = messageIconName;
    //-------------------------------

    if (giftDetail.messageInfo === "new") {
      messageStatusImage = commonUtil.getAssetURL() + "/images/gifts/new.png";
      imageName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.newmsg"
      );
      messageIconClass = "newMessage";
    }
    if (
      giftDetail.messageInfo === "replied" ||
      giftItemID === giftDetail.purchaseItemId
    ) {
      messageStatusImage =
        commonUtil.getAssetURL() + "/images/gifts/delivered.png";
      imageName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.ansmsg"
      );
      messageIconClass = "answeredMessage";
    }

    if (
      (giftDetail.messageInfo === "opened" ||
        newtoRead === giftDetail.purchaseItemId) &&
      giftItemID !== giftDetail.purchaseItemId
    ) {
      messageStatusImage = commonUtil.getAssetURL() + "/images/gifts/read.png";
      imageName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.readmsg"
      );
      messageIconClass = "readedMessage";
    }

    if (giftDetail.messageInfo === "none") {
      messageStatusImage = commonUtil.getAssetURL() + "/images/gifts/none.png";
      imageName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.nomsg"
      );
      messageIconClass = "newMessage";
    }

    // if (giftDetail.actionType === '') {
    //   deliveryStatus = giftDetail.modeofDelivery;
    // } else {
    //   deliveryStatus = giftDetail.actionType;
    // }
    // const link2 = (<button className="btnSecondarySpecial size-Full" onClick={this.modalThanks}>Send thank you message</button>);
    const _imgsrc1 = [
      {
        media: "(max-width: 465px)",
        srcSet: giftDetail.imageURL, // TODO: Need to upload all images in static asset giftDetail.image
      },
    ];
    const imageAttr1 = {
      id: "img1",
      alt: "Liverpool",
      src: giftDetail.imageURL, // TODO: Need to upload all images in static asset giftDetail.image
      altImg: giftDetail?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
      className: "img-responsive center-block receivedGiftImg",
      pictureHtmlStyle: {
        maxHeightPicture: "106px",
        maxWidthPicture: "88px",
      },
    };

    const _imgsrc2 = [
      {
        media: "(max-width: 465px)",
        srcSet: messageStatusImage, //
      },
    ];
    const imageAttr2 = {
      id: "img1",
      alt: "Liverpool",
      src: messageStatusImage, // messageStatusImage
      className: messageIconClass,
    };
    // giftDetail.skuId
    // const modalImage = (<Image imageAttr={imageAttr2} _imgsrc={_imgsrc2} onClick={() => this.getMessages1('p3067', giftDetail.messageInfo)} />);

    const modalImage = (
      <Image
        imageAttr={imageAttr2}
        _imgsrc={_imgsrc2}
        onClick={() => this.props.showProductDetail(giftDetail)}
      />
    );
    // const modalImageForNoneMSg = (<Image imageAttr={imageAttr2} _imgsrc={_imgsrc2} />);
    if (
      commonUtil.isEmpty(giftDetail) ||
      giftDetail === undefined ||
      !giftDetail.guestInfo
    ) {
      // TODO: Need to check abt guestInfo. some times I am getting this data some time not
      return null;
    }
    const giftPrice = commonUtil.getCurrency(giftDetail.price , true);
    const [giftPriceWhole, giftPricecents] = giftPrice?.split('.') ?? ['', ''];
      const giftPriceFormatted = (
        <>
        <span className="amount">{giftPriceWhole}</span><sup className="decimal">{giftPricecents}</sup>
        </>
      );

    const modalButton = (
      <div
        className="statusDeliver"
        onClick={() => this.props.selectedProductForPreview(selectedGiftDetail, giftSection)}
      >
        {commonUtil.getLabel(lables.EventAdminPage, giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
      </div>
    );

    const enableAddAgain =
      (this.props.compareEventStatus(
        this.props.eventStatus,
        defaultConst.eventStatus.ACTIVE,
      ) ||
        this.props.compareEventStatus(
          this.props.eventStatus,
          defaultConst.eventStatus.ADMINISTRATIVE_PROCESS,
        ) ||
        this.props.compareEventStatus(
          this.props.eventStatus,
          defaultConst.eventStatus.UNDER_REVIEW,
        )) &&
      (giftDetail.categoryName !== 'Gift Certificate' &&
        giftDetail.categoryName !== 'Certificado Electrónico');
    
    // const modalButton = (<div className="statusDeliver" onClick={() => this.props.trackOrder(giftDetail)}>ADD_AGAIN</div>);
    return (
      <React.Fragment>


        <div className="gift-card gift-card-received">
          <div className="row">
            <div className="col-md-6 col-sm-12">
               {/* <!-- Left: Image --> */}
                <div className="giftList-image">
                  <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
                </div>
                 {/* <!-- Center: Product details --> */}
            <div className="giftList-productDetails">
              <div className="product-title">{giftDetail.displayName}</div>
              <div className="product-meta">
                <p><strong>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.comparas.sku.by.label')}:</strong> <span className="text-muted">{giftDetail.skuId}</span></p>
                <p><strong>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosrecibidos.qty.label')}:</strong> <span className="text-muted">{giftDetail.quantity}</span></p>
                {
                  this.props.compareEventStatus(giftDetail.deliveryStatus,"physical.delivery.message") ? (
                    modalButton
                  ) : ''
                }
              </div>
            </div>
            </div>

            {/* <!-- Right: Price + Metadata --> */}
            <div className="col-md-6 col-sm-12 pl-0">
              <div className="row">
                <div className="col-sm-3">
                  <div className="price-display">
                    {giftPriceFormatted}
                  </div>
                </div>
                <div className="col-sm-9 pl-0 details-section">
                  {giftDetail && giftDetail.guestInfo ? (
                    <React.Fragment>
                      <div><strong> {commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.date.label")}:{" "}</strong> <span>{giftDetail.guestInfo.dateofPurchase}</span></div>
                      <div><strong>{commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.delivery.address.invited.label")}:{" "}</strong> <span className="text-truncate1">{giftDetail.guestInfo.name ? giftDetail.guestInfo.name : commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.guest.name")}</span></div>
                      {
                        giftDetail.modeofDelivery === "physical" && !(giftDetail.deliveryStatus == "store.delivery.message") && !(giftDetail.deliveryStatus === 'return.delivery.message' || giftDetail.deliveryStatus === 'cancel.delivery.message' || giftDetail.deliveryStatus === 'return.reinvested.delivery.message') ? (
                            <div><strong>{commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.delivery.address.label")}:{" "}</strong> <span className="text-truncate1">{giftDetail?.guestInfo?.popupDelivery ?? ''}</span></div>
                        ) : (giftDetail.deliveryStatus == "store.delivery.message") ? (
                          <div><strong>{commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.warehouse.label")}:{" "}</strong> <span className="text-truncate1">{giftDetail.guestInfo && giftDetail.guestInfo.popupStore || ''}</span></div>
                        ) : null
                      }
                      
                    </React.Fragment>
                  ) : null}
                  
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none"  onClick={() =>
                      this.props.selectedProductForPreview(selectedGiftDetail, giftSection)
                    }
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      right: '0px',
                      top: '50%',
                    }}>
                    <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
                  </svg>
                  
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Status Tags --> */}
          <div className="row status-tags">
            <div className="col-md-6 col-sm-6 pl-0 pr-0">
              <div className="giftList-image">&nbsp;</div>
            <div className="giftList-productDetails">
              {giftDetail.modeofDelivery === "physical" ? (
                <span className="tag tag-electronic"><span className="icon-home"></span>Regalo Físico</span>
              ) : (
               <span className="tag tag-electronic"><span className="icon-monetization_on"></span>Regalo electrónico</span>
              )}{" "}
              <>
                {
                  (
                    <React.Fragment>
                      {this.props.compareEventStatus(giftDetail.deliveryStatus,"store.delivery.message") ? (
                         <span className="tag statusDeliverToStore pull-right">
                          {/* Entregado en tienda */}
                           <span className="icon-circle"></span>
                          {commonUtil.getLabel(lables.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                        </span>
                      ):this.props.compareEventStatus(giftDetail.deliveryStatus, "electronic.conversion.message") ? (
                        <span className="tag tag-electronic pull-right">
                          <span className="icon-circle"></span>
                          {commonUtil.getLabel(lables.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                        </span>
                      ): this.props.compareEventStatus(giftDetail.deliveryStatus,"electronic.delivery.message") || this.props.compareEventStatus(giftDetail.deliveryStatus,"physical.delivery.message") ? (
                        <span className="tag statusDeliverToStore"></span>
                      ) : giftDetail.deliveryStatus ? (
                        <span className={`tag pull-right ${giftDetail.actionType === "returnReinvested" ? "tag-reinvested" : "tag-return"}`}>
                           <span className="icon-circle"></span>
                         {commonUtil.getLabel(lables.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                        </span>
                      ): null}
                    </React.Fragment>
                  )
                  // modalButton
                }
              </>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 pl-0 giftlist-tags-section">
              <span className={`tag tag-bono ${eventContractInfo && eventContractInfo.bonus > 0 ? "" : "tag-bono-hidden"}`}> {commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.bonus.label")}
                {giftDetail.bonusInfo === "true" && this.props.eventType !== defaultConst.eventType.Others ? (
                  <span className="icon-done"></span>
                ) : (
                  <span className="x">x</span>
              )}
              </span>
              <span className="tag tag-new-message">
                 { !(giftDetail.deliveryStatus === 'return.reinvested.delivery.message' || giftDetail.deliveryStatus === 'return.delivery.message' || giftDetail.deliveryStatus === 'cancel.delivery.message') && (
                  <React.Fragment>
                      <span className={messageIconName}></span>  { messageLabel }
                   </React.Fragment>
                 )}
              </span>
              {
                (giftDetail.actionType === 'cancel' || giftDetail.actionType === 'return' || giftDetail.actionType === 'returnReinvested')  && (
<>
                {enableAddAgain ? (
                  <button className="btn-outline-pink pull-right" onClick={() => this.props.addAgain(giftDetail.skuId)}>
                    {commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.addagain.label")}
                  </button>
                ) : (
                  <button className="btn-outline-pink pull-right" disabled>
                    {commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.addagain.label")}
                  </button>
                )}
              </>
                )
              }
              
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  messages: state.giftList.data,
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMessagesService,
      addThankYouMessage,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(mapStateToProps, matchDispatchToProps)(Template);
